import { render, staticRenderFns } from "./VivaWallet.vue?vue&type=template&id=13a6df78"
import script from "./VivaWallet.vue?vue&type=script&lang=js"
export * from "./VivaWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports